<template>
  <div
    v-if="hydrated"
    id="app"
    :class="formControl ? 'login-page' : ''"
  >
    <!-- Login and Sign Up -->
    <portal-target name="upsell-banner" />
    <template v-if="formControl">
      <b-container
        fluid
        class="login-cont cover-image"
        :style="{
          backgroundImage:
            $route.name == 'login' || $route.name == 'new-password'
              ? 'url(' + require('@/assets/images/login/bg.png') + ')'
              : $route.name == 'forgot-password'
                ? 'url(' + require('@/assets/images/login/fp.png') + ')'
                : '',
        }"
      >
        <b-row
          align-v="stretch"
          style="height: 100vh"
        >
          <b-col
            cols="12"
            lg="5"
            xxl="4"
          >
            <b-row
              style="height: 100%"
              align-v="stretch"
            >
              <b-col
                cols="12"
                align-self="start"
              >
                <b-navbar-brand
                  to="/website"
                  class="c-logo"
                >
                  <img
                    src="@/assets/images/logo/logo_w_black.svg"
                    alt=""
                  >
                </b-navbar-brand>
              </b-col>
              <b-col
                cols="12"
                align-self="start"
              >
                <vue-page-transition>
                  <router-view />
                </vue-page-transition>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="12"
            align-self="end"
            class="pb-4"
          >
            <b-row align-v="center">
              <b-col
                cols="6"
                lg="6"
              >
                <p class="mb-0">
                  ©WINONA {{ getYear }}
                </p>
              </b-col>
              <b-col
                cols="6"
                lg="6"
                class="text-right d-none d-md-block"
              >
                <b-row align-h="end">
                  <b-col
                    cols="6"
                    lg="4"
                    class="text-right"
                  >
                    <p class="d-none d-lg-block mb-0">
                      <router-link
                        v-slot="{ navigate }"
                        to="/website"
                        custom
                      >
                        <a
                          href="javascript:void(0)"
                          role="link"
                          class="text-white"
                          @click="navigate"
                        >
                          BYWINONA.COM</a>
                      </router-link>
                    </p>
                    <p class="d-block d-lg-none mb-0">
                      <router-link
                        v-slot="{ navigate }"
                        to="/website"
                        custom
                      >
                        <a
                          href="javascript:void(0)"
                          role="link"
                          class="text-primary"
                          @click="navigate"
                        >
                          BYWINONA.COM
                        </a>
                      </router-link>
                    </p>
                  </b-col>
                  <b-col
                    cols="6"
                    lg="4"
                  >
                    <p class="d-none d-lg-block mb-0">
                      <router-link
                        v-slot="{ navigate }"
                        to="/website/contact"
                        custom
                      >
                        <a
                          href="javascript:void(0)"
                          role="link"
                          class="text-white"
                          @click="navigate"
                        >
                          CONTACT US
                        </a>
                      </router-link>
                    </p>
                    <p class="d-block d-lg-none mb-0">
                      <router-link
                        v-slot="{ navigate }"
                        to="/website/contact"
                        custom
                      >
                        <a
                          href="javascript:void(0)"
                          role="link"
                          class="text-primary"
                          @click="navigate"
                        >
                          CONTACT US
                        </a>
                      </router-link>
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <template v-else>
      <div>
        <TermsModal
          v-if="showTermsCard"
          :force-accept="termsForceAccept"
          @close-force="closeTerms"
        />
        <div
          v-if="showTermsCard && termsForceAccept"
          class="tw-fixed tw-w-full tw-h-full tw-bg-slate-700 tw-opacity-20"
          style="z-index: 9998 !important"
        >
        </div>
      </div>
      <vue-page-transition>
        <div>
          <router-view />
          <FollowUpDiscountCodeSystem ref="followupModal" />
        </div>
      </vue-page-transition>
    </template>

    <div>
      <template v-if="$route.query.flow_switcher === 'true'">
        <div class="tw-fixed tw-bottom-[40%] tw-right-0 tw-z-[999] tw-p-4 tw-bg-white tw-flex tw-flex-col">
          <label
            v-for="variant in redesignFlows"
            :key="variant"
          >
            <input
              v-model="selectedVariant"
              type="radio"
              :value="variant"
              @change="setFlowVariant(variant)"
            >
            {{ variant }}
          </label>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// services
import { AuthService } from '@/services/auth.service';
import FollowUpDiscountCodeSystem from '@/components/FollowUpDiscountCodeSystem/index.vue';
// libs
import { io } from 'socket.io-client';
import VueSecureHTML from 'vue-html-secure';
import { mapState } from 'vuex';

// localstorage
import LocalStorageService from '@/localStorage';
const localStorageService = LocalStorageService.getService();

// assets
import audio from '@/assets/notifications/pop.mp3';
import doctorNotificationAudioFile from '@/assets/notifications/pristine.mp3';
import analyticsMixin from '@/mixins/analytics';
const notificationsound = new Audio(audio);
const doctorNotification = new Audio(doctorNotificationAudioFile);
const year = new Date().getFullYear();

// Top level components
import TermsModal from '@/components/partials/TermsModal.vue';

export default {
  name: 'WinonaPatient',
  components: {
    TermsModal,
    FollowUpDiscountCodeSystem
  },
  mixins: [analyticsMixin],
  data() {
    return {
      hydrated: false,
      // QA override flags
      displayOverride: false,
      termsForceAccept: true,
      selectedVariant: null,

    };
  },
  computed: {
    getYear() {
      return year;
    },
    formControl: function () {
      return (
        this.$route.name == 'login' ||
        this.$route.name == 'signup' ||
        this.$route.name == 'new-password' ||
        this.$route.name == 'forgot-password' ||
        this.$route.name == 'invitation-code'
      );
    },
    showTermsCard() {
      const tcReleaseDate = new Date('December 09, 2024');

      if (this.displayOverride) {
        return true;
      }

      const onboardingPatient = this.onboardingPatient;

      return localStorageService.getItem('accessToken') &&
        (onboardingPatient
          && onboardingPatient?.signupdate <
            (tcReleaseDate / 1000)
        ) &&
        !onboardingPatient?.acceptednewterms;
    },
    ...mapState('onboarding', ['onboardingPatient', 'redesignFlows']),
    ...mapState('global', ['isOnboardingRedesign'])
  },
  watch: {
    onboardingPatient(val) {
      if (val.onboardingstatus === 'DONE') {
        if (this.$route.name !== 'checkout') {
          document.documentElement.classList.remove('redesign');
        }
      } else {
        if (this.redesignFlows.includes(val.flow_variant)) {
          document.documentElement.classList.add('redesign');
        } else {
          document.documentElement.classList.remove('redesign');
        }
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('configuration/get'),
    ]);

    this.hydrated = true;

    if (localStorageService.getItem('accessToken')) {
      const socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
        auth: {
          token: localStorage.getItem('accessToken'),
        },
        transports: ['websocket', 'polling'],
      });
      this.$store.dispatch('socket/connectToSocket', socket);
      socket.on('connect', () => {
        console.log('Connected to server');
      });
      socket.on('connect_error', async err => {
        console.log(err);
        if (err.message === 'Invalid token') {
          this.$store.dispatch('socket/closeSocketConnection');
          await AuthService.logout();
        } else {
          socket.io.opts.transports = ['polling', 'websocket'];
        }
      });

      socket.on('token_expired', async err => {
        console.log(err);
        this.$store.dispatch('socket/closeSocketConnection');
        await AuthService.logout();
      });

      socket.on('request_error', err => {
        console.log(err);
      });

      socket.on('notification', notification => {
        const h = this.$createElement;
        const vNodesMessage = h(
          'div',
          {
            class: ['d-flex', 'p-4'],
            style: 'background: #F4F2FF;',
          },
          [
            h('div', { class: ['ml-3'] }, [
              h('p', { class: ['mb-1'] }, [
                h('strong', { style: 'font-size: 1rem' }, notification.title),
              ]),
              h(
                'p',
                { class: ['mb-0', 'text-muted'], style: 'font-size: 1rem' },
                notification.description
              ),
            ]),
          ]
        );
        this.$bvToast.hide('system-notification');
        this.$bvToast.toast([vNodesMessage], {
          visible: true,
          id: 'system-notification',
        });
        notificationsound.play();
      });

      socket.on('message', message => {
        if (message.needsreply) {
          this.$store.commit('user/SET_CURRENT_USER', {
            ...this.currentUser,
            needspatientreply: true,
          });
        }
        if (
          this.$route.name !== 'message-doctor' &&
          message.sender.id !== message.patientId
        ) {
          this.$store.dispatch('message/incrementDoctorMessagesCount');
          doctorNotification.play();
        }
      });

      socket.on('admin_chat:message', async message => {
        if (this.$route.name === 'message-admin') {
          return;
        }

        if (message.sender.id === message.patientId) {
          return
        }

        while (document.getElementById('notification')) {
          document.getElementById('notification').remove()
        }

        this.$store.dispatch('message/incrementAdminMessagesCount');

        const h = this.$createElement;
        const vNodesMessage = h(
          'div',
          {
            class: ['d-flex', 'p-4', 'position-relative'],
            style:
                'background: #F4F2FF; cursor: pointer; box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25); border-radius: 0.3rem;',
            on: {
              click: () => {
                this.$router.push('/messages/admin');
                this.$bvToast.hide('notification');
              },
            },
          },
          [
            h(
              'b-avatar',
              { style: 'background: #ece8f5; color: black' },
                message.sender?.firstName?.charAt(0)
            ),
            h('div', { class: ['ml-3'] }, [
              h('p', { class: ['mb-1'] }, [
                h(
                  'p',
                  {
                    class: ['mb-0', 'text-muted'],
                    style: 'font-size: 1rem; word-break: break-word; overflow-wrap: break-word',
                    domProps: {
                      innerHTML: message.message.length <= 85
                        ? this.removeHTML(message.message)
                        : `${this.removeHTML(message.message).substring(0, 85 - 3)}...`,
                    },
                  },
                ),
              ]),
              h(
                'p',
                {
                  class: ['mb-0', 'text-muted'],
                  style: 'font-size: 1rem; word-break: break-word; overflow-wrap: break-word',
                  domProps: {
                    innerHTML: message.message.length <= 85
                      ? this.removeHTML(message.message)
                      : `${this.removeHTML(message.message).substring(0, 85 - 3)}...`,
                  },
                },
              ),
            ]),
          ]
        );

        this.$bvToast.toast([vNodesMessage], {
          visible: true,
          noCloseButton: true,
          noAutoHide: true,
          id: 'notification',
        });

        notificationsound.play();
      });
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    openFollowUpModal() {
      this.$refs.followupModal.open();
    },
    setFlowVariant(variant) {
      this.$store.commit('onboarding/SET_FLOW_VARIANT', variant);
    },
    removeHTML(str) {
      return VueSecureHTML.removeHTML(str.replace(/<\/p>/g, ' </p>'));
    },
    closeTerms() {
      this.displayOverride = false;
      this.termsForceAccept = false;
    },
  },
};
</script>

<style lang="scss">
:root {
  color-scheme: light only;
}

@media (min-width: 992px) {
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

$svg-icons: "home", "profile", "orders", "message", "settings", "file", "rx",
  "prescription", "bell", "briefcase", "rx-request", "grid", "list";
$svg-active-icons: "home", "profile", "orders", "message", "settings";

// default bg for article-card component
.article {
  background-image: url("./assets/images/dashboard/articlebg.png");
}

// icon logo
.icon-logo {
  width: 30px;
  height: 30px;
  background-image: url("./assets/images/icon-logo.svg");
  background-size: contain;
  background-repeat: no-repeat;

  &.dark {
    background-image: url("./assets/images/dark-icon-logo.svg");
  }

  &.light {
    background-image: url("./assets/images/light-icon-logo.svg");
  }
}

.win-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  margin-left: 1.5em;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  outline: 0;
}

@each $icon in $svg-icons {
  .win-icon.is-#{$icon} {
    background-image: url("#{$svg}/#{$icon}.svg");
  }
}

@each $icon in $svg-active-icons {
  .nav-link.active .win-icon.is-#{$icon} {
    background-image: url("#{$svg}/active/#{$icon}.svg");
  }
}

.next-arrow-cyan,
.next-arrow-purple,
.next-arrow-white,
.next-arrow-aqua,
.next-arrow {
  display: inline-block;
  width: 34px;
  height: 16px;
  margin-left: 10px;
  background-image: url($next-arrow);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.next-arrow-white {
  background-image: url($next-arrow-white);
}

.next-arrow-aqua {
  background-image: url($next-arrow-aqua);
}

.next-arrow-purple {
  background-image: url($next-arrow-purple);
}

.next-arrow-cyan {
  background-image: url($next-arrow-cyan);
}

// onboarding page
.getting-started {
  letter-spacing: 0;
}

.overlay-top,
.overlay-left,
.overlay-right,
.overlay-bottom {
  z-index: 99999;
  background: $primary !important;
  transition-duration: 0.2s !important;
}

body {
  &.message-page {
    overflow: hidden;
  }
}

p {
  line-height: 1.3;
}
</style>

<style lang="scss" scoped>
#app {
  position: relative;

  &.scrollthis {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.c-logo {
  position: relative;
  top: 0;
  left: 0;
  margin-top: 2rem;

  @include media-breakpoint-down(sm) {
    margin-top: 2rem;
  }
}

.login-page {
  background-color: #e9f5f3;
}

.login-cont {
  padding: 0 5rem;
  overflow: hidden;

  @include media-breakpoint-down(sm) {
    padding: 0 1.5rem;
  }
}

.cover-image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right bottom;
  width: 100%;
  overflow: hidden;
  transition: background-image 1s cubic-bezier(0.215, 0.61, 0.355, 1);

  @include media-breakpoint-down(md) {
    background-image: none !important;
  }
}
</style>
